import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/LevelUpSettingsQuery.graphql';

export const levelUpSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-level-up-settings-entrypoint" */ './LevelUpSettings.tsx'),
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (!projectKey) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				levelUpSettingsData: {
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
			},
			extraProps: {},
		};
	},
});
